<template>
  <div
    class="main main-really-raised w-50 ml-auto mr-auto pdf-annual-report-cn"
  >
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow">
            <div
              class="card-header card-header-primary negative blue-grad w-50"
            >
              <h4 class="card-title">
                {{ $t("message.contragent_search.enterprise_risk_scan")
                }}<span v-if="doc_additional && doc_additional.request"
                  >: {{ doc_additional.request }}</span
                >
              </h4>
            </div>
            <br /><br />
            <div>
              <div
                class="card-header card-header-primary negative blue-grad rounded-0 w-50"
              >
                {{ $t("message.contragent_search.enterprise_risk_scan") }}
              </div>
              <!-- <div>
                <div class="row">
                                            <div class="col-6"><h5>{{results.Name}}</h5></div>
                                            <div class="col-6 text-right">
                                                {{results.No}}
                                            </div>
                                        </div>
                <hr>
                <div class="row">
                  <div class="col-4">
                    <img :src="results.ImageUrl" :alt="results.ImageUrl" />
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_AreaCode")
                    }}:<br /><strong>{{ results.AreaCode }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_RecCap")
                    }}:<br /><strong>{{ results.RecCap }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_EntType")
                    }}:<br /><strong>{{ results.EntType }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_StockType")
                    }}:<br /><strong>{{ results.StockType }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_StockNumber")
                    }}:<br /><strong>{{ results.StockNumber }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_IsOnStock")
                    }}:<br /><strong>{{ results.IsOnStock }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_OrgNo")
                    }}:<br /><strong>{{ results.OrgNo }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_CheckDate")
                    }}:<br /><strong>{{ results.CheckDate }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_TeamEnd")
                    }}:<br /><strong>{{ results.TeamEnd }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_TermStart")
                    }}:<br /><strong>{{ results.TermStart }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_Scope")
                    }}:<br /><strong>{{ results.Scope }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_Address")
                    }}:<br /><strong>{{ results.Address }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_EconKind")
                    }}:<br /><strong>{{ results.EconKind }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_RegistCapi")
                    }}:<br /><strong>{{ results.RegistCapi }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_CreditCode")
                    }}:<br /><strong>{{ results.CreditCode }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_UpdatedDate")
                    }}:<br /><strong>{{ results.UpdatedDate }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_Province")
                    }}:<br /><strong>{{ results.Province }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_Status")
                    }}:<br /><strong>{{ results.Status }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_EndDate")
                    }}:<br /><strong>{{ results.EndDate }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_StartDate")
                    }}:<br /><strong>{{ results.StartDate }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_OperName")
                    }}:<br /><strong>{{ results.OperName }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_OperId")
                    }}:<br /><strong>{{ results.OperId }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_BelongOrg")
                    }}:<br /><strong>{{ results.BelongOrg }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_No")
                    }}:<br /><strong>{{ results.No }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_Name")
                    }}:<br /><strong>{{ results.Name }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_KeyNo")
                    }}:<br /><strong>{{ results.KeyNo }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_IXCode")
                    }}:<br /><strong>{{ results.IXCode }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_PersonScope")
                    }}:<br /><strong>{{ results.PersonScope }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_EnglishName")
                    }}:<br /><strong>{{ results.EnglishName }}</strong>
                  </div>
                  <div class="col-4 mb-2">
                    {{
                      $t("message.contragent_search.ers_InsuredCount")
                    }}:<br /><strong>{{ results.InsuredCount }}</strong>
                  </div>

                  <div class="col-4 mb-2" v-if="results.Liquidation">
                    {{
                      $t("message.contragent_search.ers_Liquidation")
                    }}:<br /><strong
                      >{{ results.Liquidation.Leader }} -
                      {{ results.Liquidation.Member }}</strong
                    >
                  </div>
                  <div
                    class="col-4 mb-2"
                    v-if="typeof results.ContactInfo !== 'undefined'"
                  >
                    {{
                      $t("message.contragent_search.ers_ContactInfo")
                    }}:<br /><strong
                      ><span
                        v-if="
                          typeof results.ContactInfo !== 'undefined' &&
                          results.ContactInfo.WebSite
                        "
                        >{{ results.ContactInfo.WebSite.Url }}<br /></span
                      >{{ results.ContactInfo.PhoneNumber }}<br />{{
                        results.ContactInfo.Email
                      }}</strong
                    >
                  </div>
                  <div class="col-4 mb-2">
                    {{ $t("message.contragent_search.ers_Industry") }}:<br />
                    <strong
                      >{{
                        $t("message.contragent_search.ers_ind_IndustryCode")
                      }}: {{ IndustryList.IndustryCode }}</strong
                    ><br />
                    <strong
                      >{{ $t("message.contragent_search.ers_ind_Industry") }}:
                      {{ IndustryList.Industry }}</strong
                    ><br />
                    <strong
                      >{{
                        $t("message.contragent_search.ers_ind_SubIndustryCode")
                      }}: {{ IndustryList.SubIndustryCode }}</strong
                    ><br />
                    <strong
                      >{{
                        $t("message.contragent_search.ers_ind_SubIndustry")
                      }}: {{ IndustryList.SubIndustry }}</strong
                    ><br />
                    <strong
                      >{{
                        $t(
                          "message.contragent_search.ers_ind_MiddleCategoryCode",
                        )
                      }}: {{ IndustryList.MiddleCategoryCode }}</strong
                    ><br />
                    <strong
                      >{{
                        $t("message.contragent_search.ers_ind_MiddleCategory")
                      }}: {{ IndustryList.MiddleCategory }}</strong
                    ><br />
                    <strong
                      >{{
                        $t(
                          "message.contragent_search.ers_ind_SmallCategoryCode",
                        )
                      }}: {{ IndustryList.SmallCategoryCode }}</strong
                    ><br />
                    <strong
                      >{{
                        $t("message.contragent_search.ers_ind_SmallCategory")
                      }}: {{ IndustryList.SmallCategory }}</strong
                    ><br />
                  </div>
                  <div class="col-4 mb-2">
                    {{ $t("message.contragent_search.ers_Area") }}:<br />
                    <strong
                      >{{ $t("message.contragent_search.ers_area_Province") }}:
                      {{ AreaList.Province }}</strong
                    ><br />
                    <strong
                      >{{ $t("message.contragent_search.ers_area_City") }}:
                      {{ AreaList.City }}</strong
                    ><br />
                    <strong
                      >{{ $t("message.contragent_search.ers_area_County") }}:
                      {{ AreaList.County }}</strong
                    ><br />
                  </div>
                  <div class="col-4 mb-2">
                    {{ $t("message.contragent_search.ers_RevokeInfo") }}:<br />
                    <strong
                      >{{ $t("message.contragent_search.ers_rev_CancelDate") }}:
                      {{ RevokeInfoList.CancelDate }}</strong
                    ><br />
                    <strong
                      >{{
                        $t("message.contragent_search.ers_rev_CancelReason")
                      }}: {{ RevokeInfoList.CancelReason }}</strong
                    ><br />
                    <strong
                      >{{ $t("message.contragent_search.ers_rev_RevokeDate") }}:
                      {{ RevokeInfoList.RevokeDate }}</strong
                    ><br />
                    <strong
                      >{{
                        $t("message.contragent_search.ers_rev_RevokeReason")
                      }}: {{ RevokeInfoList.RevokeReason }}</strong
                    ><br />
                  </div>
                </div>
              </div> -->

              <!-- <h5
                class="card-header card-header-primary negative blue-grad rounded-0 w-50"
              >
                {{ $t("message.contragent_search.ers_PermissionInfo") }}
              </h5>
              <div>
                <div>
                  <b-table
                    :fields="PermissionInfo_fields"
                    :items="results.PermissionInfo"
                  ></b-table>
                </div>
              </div> -->
              <h5
                class="card-header card-header-primary negative blue-grad rounded-0 w-50"
              >
                {{ $t("message.contragent_search.ers_Penalty") }}
              </h5>
              <div>
                <div>
                  <b-table
                    :fields="Penalty_fields"
                    :items="results.Penalty"
                  ></b-table>
                </div>
              </div>
              <h5
                class="card-header card-header-primary negative blue-grad rounded-0 w-50"
              >
                {{ $t("message.contragent_search.ers_Exceptions") }}
              </h5>
              <div>
                <div>
                  <b-table
                    :fields="Exceptions_fields"
                    :items="results.Exceptions"
                  ></b-table>
                </div>
              </div>
              <h5
                class="card-header card-header-primary negative blue-grad rounded-0 w-50"
              >
                {{ $t("message.contragent_search.ers_ShiXinItems") }}
              </h5>
              <div>
                <div>
                  <b-table
                    :fields="ShiXinItems_fields"
                    :items="results.ShiXinItems"
                  ></b-table>
                </div>
              </div>
              <h5
                class="card-header card-header-primary negative blue-grad rounded-0 w-50"
              >
                {{ $t("message.contragent_search.ers_ZhiXingItems") }}
              </h5>
              <div>
                <div>
                  <b-table
                    :fields="ZhiXingItems_fields"
                    :items="results.ZhiXingItems"
                  ></b-table>
                </div>
              </div>
              <h5
                class="card-header card-header-primary negative blue-grad rounded-0 w-50"
              >
                {{ $t("message.contragent_search.ers_MPledge") }}
              </h5>
              <div>
                <div>
                  <b-table
                    :fields="MPledge_fields"
                    :items="results.MPledge"
                  ></b-table>
                </div>
              </div>
              <h5
                class="card-header card-header-primary negative blue-grad rounded-0 w-50"
              >
                {{ $t("message.contragent_search.ers_Pledge") }}
              </h5>
              <div>
                <div>
                  <b-table
                    :fields="Pledge_fields"
                    :items="results.Pledge"
                  ></b-table>
                </div>
              </div>
              <h5
                class="card-header card-header-primary negative blue-grad rounded-0 w-50"
              >
                {{ $t("message.contragent_search.ers_SpotCheck") }}
              </h5>
              <div>
                <div>
                  <b-table
                    :fields="SpotCheck_fields"
                    :items="results.SpotCheck"
                  ></b-table>
                </div>
              </div>
              <h5
                class="card-header card-header-primary negative blue-grad rounded-0 w-50"
              >
                {{ $t("message.contragent_search.ers_CompanyTaxCreditItems") }}
              </h5>
              <div>
                <div>
                  <b-table
                    :fields="CompanyTaxCreditItems_fields"
                    :items="results.CompanyTaxCreditItems"
                  ></b-table>
                </div>
              </div>
              <h5
                class="card-header card-header-primary negative blue-grad rounded-0 w-50"
              >
                {{ $t("message.contragent_search.ers_CompanyProducts") }}
              </h5>
              <div>
                <div>
                  <b-table
                    :fields="CompanyProducts_fields"
                    :items="results.CompanyProducts"
                  ></b-table>
                </div>
              </div>
              <h5
                class="card-header card-header-primary negative blue-grad rounded-0 w-50"
              >
                {{ $t("message.contragent_search.ers_PermissionEciInfo") }}
              </h5>
              <div>
                <div>
                  <b-table
                    :fields="PermissionEciInfo_fields"
                    :items="results.PermissionEciInfo"
                  ></b-table>
                </div>
              </div>
              <h5
                class="card-header card-header-primary negative blue-grad rounded-0 w-50"
              >
                {{ $t("message.contragent_search.ers_PenaltyCreditChina") }}
              </h5>
              <div>
                <div>
                  <b-table
                    :fields="PenaltyCreditChina_fields"
                    :items="results.PenaltyCreditChina"
                  ></b-table>
                </div>
              </div>
              <h5
                class="card-header card-header-primary negative blue-grad rounded-0 w-50"
              >
                {{ $t("message.contragent_search.ers_Partners") }}
              </h5>
              <div>
                <div>
                  <b-table
                    :fields="Partners_fields"
                    :items="results.Partners"
                  ></b-table>
                </div>
              </div>
              <h5
                class="card-header card-header-primary negative blue-grad rounded-0 w-50"
              >
                {{ $t("message.contragent_search.ers_Employees") }}
              </h5>
              <div>
                <div>
                  <b-table
                    :fields="Employees_fields"
                    :items="results.Employees"
                  ></b-table>
                </div>
              </div>
              <h5
                class="card-header card-header-primary negative blue-grad rounded-0 w-50"
              >
                {{ $t("message.contragent_search.ers_Branches") }}
              </h5>
              <div>
                <div>
                  <b-table
                    :fields="Branches_fields"
                    :items="results.Branches"
                  ></b-table>
                </div>
              </div>
              <!-- <h5
                class="card-header card-header-primary negative blue-grad rounded-0 w-50"
              >
                {{ $t("message.contragent_search.ers_ChangeRecords") }}
              </h5>
              <div>
                <div>
                  <b-table
                    :fields="ChangeRecords_fields"
                    :items="results.ChangeRecords"
                  ></b-table>
                </div>
              </div> -->
              <h5
                class="card-header card-header-primary negative blue-grad rounded-0 w-50"
              >
                {{ $t("message.contragent_search.ers_EmergingIndustyList") }}
              </h5>
              <div>
                <div>
                  <b-table
                    :fields="EmergingIndustyList_fields"
                    :items="results.EmergingIndustyList"
                  ></b-table>
                </div>
              </div>
              <h5
                class="card-header card-header-primary negative blue-grad rounded-0 w-50"
              >
                {{ $t("message.contragent_search.ers_TagList") }}
              </h5>
              <div>
                <div>
                  <b-table
                    :fields="TagList_fields"
                    :items="results.TagList"
                  ></b-table>
                </div>
              </div>
              <h5
                class="card-header card-header-primary negative blue-grad rounded-0 w-50"
              >
                {{ $t("message.contragent_search.ers_ARContactList") }}
              </h5>
              <div>
                <div>
                  <b-table
                    :fields="ARContactList_fields"
                    :items="results.ARContactList"
                  ></b-table>
                </div>
              </div>
              <h5
                class="card-header card-header-primary negative blue-grad rounded-0 w-50"
              >
                {{ $t("message.contragent_search.ers_OriginalName") }}
              </h5>
              <div>
                <div>
                  <b-table
                    :fields="OriginalName_fields"
                    :items="results.OriginalName"
                  ></b-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: ["user_id", "doc_id", "doc", "goods", "doc_additional"],
  data() {
    return {
      current_tab: 0,
      response_info: {},
      service_info: {},
      service_info_objects: {},
      keyWord: "",
      results: [],
      IndustryList: [],
      AreaList: [],

      PermissionInfoList: [],
      PenaltyList: [],
      ExceptionsList: [],
      ShiXinItemsList: [],
      ZhiXingItemsList: [],
      MPledgeList: [],
      PledgeList: [],
      SpotCheckList: [],
      CompanyTaxCreditItemsList: [],
      CompanyProductsList: [],
      PermissionEciInfoList: [],
      PenaltyCreditChinaList: [],
      PartnersList: [],
      EmployeesList: [],
      BranchesList: [],
      ChangeRecordsList: [],
      EmergingIndustyList: [],
      TagList: [],
      ARContactList: [],
      OriginalNameList: [],
      RevokeInfoList: [],
      PermissionInfo_fields: [
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        {
          key: "Province",
          label: this.$t("message.contragent_search.ers_pi_Province"),
        },
        {
          key: "Liandate",
          label: this.$t("message.contragent_search.ers_pi_Liandate"),
        },
        {
          key: "CaseNo",
          label: this.$t("message.contragent_search.ers_pi_CaseNo"),
        },
      ],
      Penalty_fields: [
        {
          key: "DocNo",
          label: this.$t("message.contragent_search.ers_pi_DocNo"),
        },
        {
          key: "PenaltyType",
          label: this.$t("message.contragent_search.ers_pi_PenaltyType"),
        },
        {
          key: "OfficeName",
          label: this.$t("message.contragent_search.ers_pi_OfficeName"),
        },
        {
          key: "Content",
          label: this.$t("message.contragent_search.ers_pi_Content"),
        },
        {
          key: "PenaltyDate",
          label: this.$t("message.contragent_search.ers_pi_PenaltyDate"),
        },
        {
          key: "PublicDate",
          label: this.$t("message.contragent_search.ers_pi_PublicDate"),
        },
        {
          key: "Remark",
          label: this.$t("message.contragent_search.ers_pi_Remark"),
        },
      ],
      Exceptions_fields: [
        {
          key: "AddReason",
          label: this.$t("message.contragent_search.ers_pi_AddReason"),
        },
        {
          key: "AddDate",
          label: this.$t("message.contragent_search.ers_pi_AddDate"),
        },
        {
          key: "RomoveReason",
          label: this.$t("message.contragent_search.ers_pi_RomoveReason"),
        },
        {
          key: "RemoveDate",
          label: this.$t("message.contragent_search.ers_pi_RemoveDate"),
        },
        {
          key: "DecisionOffice",
          label: this.$t("message.contragent_search.ers_pi_DecisionOffice"),
        },
        {
          key: "RemoveDecisionOffice",
          label: this.$t(
            "message.contragent_search.ers_pi_RemoveDecisionOffice",
          ),
        },
      ],
      ShiXinItems_fields: [
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        {
          key: "Liandate",
          label: this.$t("message.contragent_search.ers_pi_Liandate"),
        },
        {
          key: "Anno",
          label: this.$t("message.contragent_search.ers_pi_Anno"),
        },
        {
          key: "Orgno",
          label: this.$t("message.contragent_search.ers_pi_Orgno"),
        },
        {
          key: "Execute",
          label: this.$t("message.contragent_search.ers_pi_Execute"),
        },
        {
          key: "Publicdate",
          label: this.$t("message.contragent_search.ers_pi_Publicdate"),
        },
        {
          key: "Executestatus",
          label: this.$t("message.contragent_search.ers_pi_Executestatus"),
        },
        {
          key: "Actionremark",
          label: this.$t("message.contragent_search.ers_pi_Actionremark"),
        },
        {
          key: "Executegov",
          label: this.$t("message.contragent_search.ers_pi_Executegov"),
        },
      ],
      ZhiXingItems_fields: [
        { key: "Id", label: this.$t("message.contragent_search.ers_pi_Id") },
        {
          key: "Sourceid",
          label: this.$t("message.contragent_search.ers_pi_Sourceid"),
        },
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        {
          key: "Liandate",
          label: this.$t("message.contragent_search.ers_pi_Liandate"),
        },
        {
          key: "Anno",
          label: this.$t("message.contragent_search.ers_pi_Anno"),
        },
        {
          key: "ExecuteGov",
          label: this.$t("message.contragent_search.ers_pi_ExecuteGov"),
        },
        {
          key: "Biaodi",
          label: this.$t("message.contragent_search.ers_pi_Biaodi"),
        },
        {
          key: "Status",
          label: this.$t("message.contragent_search.ers_pi_Status"),
        },
        {
          key: "PartyCardNum",
          label: this.$t("message.contragent_search.ers_pi_PartyCardNum"),
        },
        {
          key: "Updatedate",
          label: this.$t("message.contragent_search.ers_pi_Updatedate"),
        },
      ],
      MPledge_fields: [
        {
          key: "RegisterNo",
          label: this.$t("message.contragent_search.ers_pi_RegisterNo"),
        },
        {
          key: "RegisterDate",
          label: this.$t("message.contragent_search.ers_pi_RegisterDate"),
        },
        {
          key: "PublicDate",
          label: this.$t("message.contragent_search.ers_pi_PublicDate"),
        },
        {
          key: "RegisterOffice",
          label: this.$t("message.contragent_search.ers_pi_RegisterOffice"),
        },
        {
          key: "DebtSecuredAmount",
          label: this.$t("message.contragent_search.ers_pi_DebtSecuredAmount"),
        },
        {
          key: "Status",
          label: this.$t("message.contragent_search.ers_pi_Status"),
        },
      ],
      Pledge_fields: [
        {
          key: "CompanyId",
          label: this.$t("message.contragent_search.ers_pi_CompanyId"),
        },
        {
          key: "RegistNo",
          label: this.$t("message.contragent_search.ers_pi_RegistNo"),
        },
        {
          key: "Pledgor",
          label: this.$t("message.contragent_search.ers_pi_Pledgor"),
        },
        {
          key: "PledgorNo",
          label: this.$t("message.contragent_search.ers_pi_PledgorNo"),
        },
        {
          key: "Pledge",
          label: this.$t("message.contragent_search.ers_pi_Pledge"),
        },
        {
          key: "PledgeNo",
          label: this.$t("message.contragent_search.ers_pi_PledgeNo"),
        },
        {
          key: "PledgedAmount",
          label: this.$t("message.contragent_search.ers_pi_PledgedAmount"),
        },
        {
          key: "RegDate",
          label: this.$t("message.contragent_search.ers_pi_RegDate"),
        },
        {
          key: "PublicDate",
          label: this.$t("message.contragent_search.ers_pi_PublicDate"),
        },
        {
          key: "Status",
          label: this.$t("message.contragent_search.ers_pi_Status"),
        },
      ],
      SpotCheck_fields: [
        { key: "No", label: this.$t("message.contragent_search.ers_pi_No") },
        {
          key: "ExecutiveOrg",
          label: this.$t("message.contragent_search.ers_pi_ExecutiveOrg"),
        },
        {
          key: "Type",
          label: this.$t("message.contragent_search.ers_pi_Type"),
        },
        {
          key: "Date",
          label: this.$t("message.contragent_search.ers_pi_Date"),
        },
        {
          key: "Consequence",
          label: this.$t("message.contragent_search.ers_pi_Consequence"),
        },
        {
          key: "Remark",
          label: this.$t("message.contragent_search.ers_pi_Remark"),
        },
      ],
      CompanyTaxCreditItems_fields: [
        { key: "No", label: this.$t("message.contragent_search.ers_pi_No") },
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        {
          key: "Year",
          label: this.$t("message.contragent_search.ers_pi_Year"),
        },
        {
          key: "Level",
          label: this.$t("message.contragent_search.ers_pi_Level"),
        },
      ],
      CompanyProducts_fields: [
        {
          key: "CompanyName",
          label: this.$t("message.contragent_search.ers_pi_CompanyName"),
        },
        {
          key: "Link",
          label: this.$t("message.contragent_search.ers_pi_Link"),
        },
        {
          key: "ImageUrl",
          label: this.$t("message.contragent_search.ers_pi_ImageUrl"),
        },
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        {
          key: "Domain",
          label: this.$t("message.contragent_search.ers_pi_Domain"),
        },
        {
          key: "Tags",
          label: this.$t("message.contragent_search.ers_pi_Tags"),
        },
        {
          key: "Description",
          label: this.$t("message.contragent_search.ers_pi_Description"),
        },
        {
          key: "Category",
          label: this.$t("message.contragent_search.ers_pi_Category"),
        },
      ],
      PermissionEciInfo_fields: [
        {
          key: "LicensDocNo",
          label: this.$t("message.contragent_search.ers_pi_LicensesDocNo"),
        },
        {
          key: "LicensDocName",
          label: this.$t("message.contragent_search.ers_pi_LicensesDocName"),
        },
        {
          key: "ValidityFrom",
          label: this.$t("message.contragent_search.ers_pi_ValidityFrom"),
        },
        {
          key: "ValidityTo",
          label: this.$t("message.contragent_search.ers_pi_ValidityTo"),
        },
        {
          key: "LicensOffice",
          label: this.$t("message.contragent_search.ers_pi_LicensOffice"),
        },
        {
          key: "LicensContent",
          label: this.$t("message.contragent_search.ers_pi_LicensesContent"),
        },
      ],
      PenaltyCreditChina_fields: [
        {
          key: "CaseNo",
          label: this.$t("message.contragent_search.ers_pi_CaseNo"),
        },
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        {
          key: "Liandate",
          label: this.$t("message.contragent_search.ers_pi_Liandate"),
        },
        {
          key: "Province",
          label: this.$t("message.contragent_search.ers_pi_Province"),
        },
        {
          key: "OwnerName",
          label: this.$t("message.contragent_search.ers_pi_OwnerName"),
        },
        {
          key: "CaseReason",
          label: this.$t("message.contragent_search.ers_pi_CaseReason"),
        },
      ],
      Partners_fields: [
        {
          key: "KeyNo",
          label: this.$t("message.contragent_search.ers_pi_KeyNo"),
        },
        {
          key: "StockName",
          label: this.$t("message.contragent_search.ers_pi_StockName"),
        },
        {
          key: "StockType",
          label: this.$t("message.contragent_search.ers_pi_StockType"),
        },
        {
          key: "StockPercent",
          label: this.$t("message.contragent_search.ers_pi_StockPercent"),
        },
        {
          key: "ShouldCapi",
          label: this.$t("message.contragent_search.ers_pi_ShouldCapi"),
        },
        {
          key: "ShouldDate",
          label: this.$t("message.contragent_search.ers_pi_ShouldDate"),
        },
        {
          key: "InvestType",
          label: this.$t("message.contragent_search.ers_pi_InvestType"),
        },
        {
          key: "InvestName",
          label: this.$t("message.contragent_search.ers_pi_InvestName"),
        },
        {
          key: "RealCapi",
          label: this.$t("message.contragent_search.ers_pi_RealCapi"),
        },
        {
          key: "CapiDate",
          label: this.$t("message.contragent_search.ers_pi_CapiDate"),
        },
        {
          key: "TagsList",
          label: this.$t("message.contragent_search.ers_pi_TagsList"),
        },
        {
          key: "FinalBenefitPercent",
          label: this.$t(
            "message.contragent_search.ers_pi_FinalBenefitPercent",
          ),
        },
        {
          key: "RelatedProduct",
          label: this.$t("message.contragent_search.ers_pi_RelatedProduct"),
        },
        {
          key: "RelatedOrg",
          label: this.$t("message.contragent_search.ers_pi_RelatedOrg"),
        },
      ],
      Employees_fields: [
        {
          key: "KeyNo",
          label: this.$t("message.contragent_search.ers_pi_KeyNo"),
        },
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        { key: "Job", label: this.$t("message.contragent_search.ers_pi_Job") },
      ],
      Branches_fields: [
        {
          key: "CompanyId",
          label: this.$t("message.contragent_search.ers_pi_CompanyId"),
        },
        {
          key: "RegNo",
          label: this.$t("message.contragent_search.ers_pi_RegNo"),
        },
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        {
          key: "BelongOrg",
          label: this.$t("message.contragent_search.ers_pi_BelongOrg"),
        },
        {
          key: "CreditCode",
          label: this.$t("message.contragent_search.ers_pi_CreditCode"),
        },
        {
          key: "OperName",
          label: this.$t("message.contragent_search.ers_pi_OperName"),
        },
      ],
      ChangeRecords_fields: [
        {
          key: "ProjectName",
          label: this.$t("message.contragent_search.ers_pi_ProjectName"),
        },
        {
          key: "BeforeContent",
          label: this.$t("message.contragent_search.ers_pi_BeforeContent"),
        },
        {
          key: "AfterContent",
          label: this.$t("message.contragent_search.ers_pi_AfterContent"),
        },
        {
          key: "ChangeDate",
          label: this.$t("message.contragent_search.ers_pi_ChangeDate"),
        },
      ],
      EmergingIndustyList_fields: [
        {
          key: "IndustryCode",
          label: this.$t("message.contragent_search.ers_pi_IndustryCode"),
        },
        {
          key: "Industry",
          label: this.$t("message.contragent_search.ers_pi_Industry"),
        },
        {
          key: "SubIndustryCode",
          label: this.$t("message.contragent_search.ers_pi_SubIndustryCode"),
        },
        {
          key: "SubIndustry",
          label: this.$t("message.contragent_search.ers_pi_SubIndustry"),
        },
        {
          key: "MiddleCategoryCode",
          label: this.$t("message.contragent_search.ers_pi_MiddleCategoryCode"),
        },
        {
          key: "MiddleCategory",
          label: this.$t("message.contragent_search.ers_pi_MiddleCategory"),
        },
        {
          key: "SmallCategoryCode",
          label: this.$t("message.contragent_search.ers_pi_SmallCategoryCode"),
        },
        {
          key: "SmallCategory",
          label: this.$t("message.contragent_search.ers_pi_SmallCategory"),
        },
      ],
      TagList_fields: [
        {
          key: "Type",
          label: this.$t("message.contragent_search.ers_pi_Type"),
        },
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
      ],
      ARContactList_fields: [
        {
          key: "ContactNo",
          label: this.$t("message.contragent_search.ers_pi_ContactNo"),
        },
        {
          key: "EmailAddress",
          label: this.$t("message.contragent_search.ers_pi_EmailAddress"),
        },
        {
          key: "Address",
          label: this.$t("message.contragent_search.ers_pi_Address"),
        },
      ],
      OriginalName_fields: [
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        {
          key: "ChangeDate",
          label: this.$t("message.contragent_search.ers_pi_ChangeDate"),
        },
      ],
    };
  },
  mounted() {
    this.service_info = Object.entries(this.doc);
    this.results = this.doc;
    this.PenaltyList = this.doc.PenaltyList;
    this.ExceptionsList = this.doc.ExceptionsList;
    this.ShiXinItemsList = this.doc.ShiXinItemsList;
    this.ZhiXingItemsList = this.doc.ZhiXingItemsList;
    this.MPledgeList = this.doc.MPledgeList;
    this.PledgeList = this.doc.PledgeList;
    this.SpotCheckList = this.doc.SpotCheckList;
    this.CompanyTaxCreditItemsList = this.doc.CompanyTaxCreditItemsList;
    this.CompanyProductsList = this.doc.CompanyProductsList;
    this.PermissionEciInfoList = this.doc.PermissionEciInfoList;
    this.PenaltyCreditChinaList = this.doc.PenaltyCreditChinaList;
    this.PartnersList = this.doc.PartnersList;
    this.EmployeesList = this.doc.EmployeesList;
    this.BranchesList = this.doc.BranchesList;
    this.ChangeRecordsList = this.doc.ChangeRecordsList;
    this.EmergingIndustyList = this.doc.EmergingIndustyList;
    this.TagList = this.doc.TagList;
    this.ARContactList = this.doc.ARContactList;
    this.OriginalNameList = this.doc.OriginalNameList;
    this.results.ContactInfo = this.doc.ContactInfo;
    this.RevokeInfoList = this.doc.RevokeInfoList;
    console.log("results", this.doc);
    this.service_info_objects = this.service_info.filter(
      (item) =>
        typeof item[1] === "object" && item[1] !== null && !_.isArray(item[1]),
    );
    this.service_info = this.service_info.filter(
      (item) => typeof item[1] !== "object" && !_.isArray(item[1]),
    );
    setTimeout(() => {
      this.$root.$emit("print-pdf", {
        signature: "",
        type: "company-info-service-cn",
      });
    }, 2000);
  },
  computed: {},
  methods: {
    /**
     * Gets array of data-fields from the array of Results for the fields, that are arrays of objects
     * @param {Array} result – result record for company with list of results
     * @param {String} field - field to get array of
     */
    resultsDataList(result, field) {
      const results = [];
      result.results.forEach((result_) => {
        result_[field].forEach((item) => {
          results.push(item);
        });
      });
      return results;
    },
    /**
     * Gets array of data-fields from the array of Results
     * @param {Array} result – result record for company with list of results
     * @param {String} field - field to get array of
     */
    resultsData(result, field) {
      return result.results.map((result_) => {
        return {
          ...result_[field],
          Year: result_.Year,
          PublishDate: result_.PublishDate,
          No: result_.No,
        };
      });
    },
    momentum(d) {
      return moment(d).format("D.MM.Y");
    },
    // searchCompanyInfo() {
    //     axios.get(window.base+'/admin/GetBillingServiceInfo?code=430')
    // 		.then(response=>{
    // 			this.$bvModal.msgBoxConfirm(this.$t('message.find_partner.cn_company_info_check_alert') + ' ' + response.data.billing_service_price + ' ' + response.data.billing_service_cur, {
    // 				title: this.$t('message.confirm'),
    // 				size: 'sm',
    // 				buttonSize: 'sm',
    // 				okVariant: 'danger',
    // 				okTitle: this.$t('message.yes'),
    // 				cancelTitle: this.$t('message.no'),
    // 				footerClass: 'p-2',
    // 				hideHeaderClose: false,
    // 				centered: true
    // 				}).then(value => {
    // 					if(value){
    // 						axios.get(window.base + '/library/openAPIQCCMockup?keyWord=' + this.keyWord).then(response => {
    //                         this.searchComplete = true;
    //                         this.service_info = Object.entries(response.data.Result);
    //                         this.response_info = response.data.Result;
    //                         this.service_info_objects = this.service_info.filter(item => typeof item[1] === 'object' && item[1] !== null && !_.isArray(item[1]));

    //                         console.log('service info objects');
    //                         console.log(this.service_info_objects);

    //                         this.service_info = this.service_info.filter(item => typeof item[1] !== 'object' && !_.isArray(item[1]));

    //                         console.log('service info');
    //                         console.log(this.service_info);
    //                     })
    // 					}
    // 				})
    // 		})

    // }
  },
};
</script>
